import ThemeListingItem from "./theme-listing-item";

interface ThemeListingProp {
  app?: boolean;
  themes: {
    slug: string;
    name: string;
    price: string;
    image: string;
    colors: string[];
    Variants: any[];
  }[];
}

const ThemeListing: React.FC<ThemeListingProp> = ({ themes, app }) => (
  <div className="theme-listing">
    <div className="container container--small">
      <div className="theme-listing__inner">
        {themes?.map((theme: ThemeListingProp["themes"][0], index) =>
          theme?.Variants ? (
            theme?.Variants.map((themeVariant: any, key) => (
              <ThemeListingItem
                key={key}
                theme={theme}
                variant={themeVariant}
                app={app}
              />
            ))
          ) : (
            <ThemeListingItem key={index} theme={theme} app={app} />
          )
        )}
      </div>
    </div>
  </div>
);

export default ThemeListing;
